export function isReactSnap() {
    return navigator.userAgent === 'ReactSnap';
  }